// Libs
import axios from "../configRequest";
// Data
import { I_AXIOS } from "../configRequest.model";
import { I_getBuyoutReject_response, I_getBuyoutReject } from "./apiGetBuyoutReject.types";

const apiGetBuyoutReject: I_getBuyoutReject_response = async (token: string, lang: string) => {
    const fetchData = await axios.get<I_getBuyoutReject[]>(
        I_AXIOS.STAGE_API_HOST + "/api/tin/v1/site/quest/agc-reject-reasons",
        {
            params: {
                typeId: "TIW",
                token,
                lang,
            },
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json",
            },
        },
    );

    return fetchData.data;
};

export default apiGetBuyoutReject;
